import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { IconButton, Button } from "@material-ui/core";
import Launch from "@material-ui/icons/Launch";
import Add from "@material-ui/icons/Add";
import Print from "@material-ui/icons/Print";

export default class CourseTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoaded: false,
    };
  }

  onActionClick(el) {
    this.props.actionClick(el);
  }

  onPrintClick(el) {
    this.props.printClick(el);
  }

  onButtonClick = (id) => {
    this.props.onButtonClick(id);
  };

  render() {
    const columns = [
      {
        name: "#",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Sl No",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Certificate Type",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Student Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Father's Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Mother's Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Gender",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Address",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Course",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Semester",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Roll No",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Payment",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Library Status",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Status",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Timestamp",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Action",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (el) => (
            <div>
              {el.status == 1 ? (
                <>
                  <a
                    target="_blank"
                    href={`http://localhost:3003/certificate-print?certificate_no=${btoa(el.certificate_sl_no)}`}
                  >
                    <Button
                      size="small"
                      color="primary"
                    >
                      Print
                    </Button>
                  </a>
                </>
              ) : null}
            </div>
          ),
        },
      },
    ];

    const options = {
      filterType: "checkbox",
      selectableRows: false,
      responsive: "scroll",
      customToolbar: () => {
        return (
          <IconButton onClick={this.props.onAddClick}>
            <Add />
          </IconButton>
        );
      },
    };

    let data = [];
    let table_data = this.props.table_data;
    if (table_data.length > 0) {
      data = table_data.map((el, index) => [
        index + 1,
        el.certificate_sl_no,
        el.type_name,
        el.name,
        el.father_name,
        el.mother_name,
        el.gender,
        el.address,
        el.course,
        el.semester,
        el.roll_no,
        el.payment_status == 1
          ? `Rs. ${el.amount_paid} on ${el.amount_paid_on}`
          : `Not Paid`,
        el.library_status == 0
          ? "Pending"
          : el.library_status == 1
          ? `Approved on ${el.library_verification_on}`
          : "Rejected",
        el.status == 0
          ? "Pending"
          : el.status == 1
          ? "Generated"
          : `Cancelled, ${el.cancel_reason}`,
        el.time_stamp,
        el,
      ]);
    } else {
      data = [];
    }

    return (
      <div>
        <MUIDataTable
          title={"Certificates Generated"}
          data={data}
          columns={columns}
          options={options}
        />
      </div>
    );
  }
}
